import { MaintenanceAlert } from "components/common";
import { SearchWithFilter } from "components/search";

const AnatomiskPage = () => {
  return (
    <>
      <MaintenanceAlert />
      <SearchWithFilter />
    </>
  );
};

export default AnatomiskPage;
